<div class="wrap">

  <div *ngIf="preferenceData" class="email-preferences-container">
      <img title="Orbitax" src="https://dev-partners-wordpress-backup.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/06/12171034/orbitax_logo_dark.svg" alt="Orbitax Logo">
    <h1>Email Preferences</h1>
    <p>Update your Orbitax Email Preferences</p>
    <div class="table-container">
      <table>
        <tr>
          <th>Notice</th>
          <th>Email Inbox</th>
        </tr>

        <tr *ngFor="let preference of preferenceData; let i = index">
          <td>
            <div class="second-header-text">
              {{preference.title}}
            </div>
            <span>
            {{preference.description}}.
          </span>
          </td>
          <td>
            <mat-slide-toggle
              [checked]="preference.emailInboxEnabled"
              (change)="handleEmailClick($event, i)">
              <div *ngIf="preference.emailInboxEnabled">On</div>
              <div *ngIf="!preference.emailInboxEnabled">Off</div>
            </mat-slide-toggle>
          </td>
        </tr>
      </table>
    </div>
    <div class="button-container w-p-100">
      <div class="blue-box-container"><span>Note: </span>You will always receive essential emails such as changes to
        your accounts or license.
      </div>
      <button mat-button
              class="action-button w-p-100"
              type="button"
              (click)="updatePreference()">
        Update my preferences
      </button>
    </div>
  </div>

  <div *ngIf="!preferenceData" class="blue-box-container text-center"><span>Note: </span>Sorry, Something is wrong.
  </div>

</div>
